'use client';

import { useState, useRef, useEffect } from 'react'
import Image from 'next/image';

// Assets
import FullScreenIcon from "@public/png/full-screen-1.png"
import PauseIcon from "@public/png/pause-1.png"
import PlayIcon from "@public/png/play-1.png"
import SpeakerOff from "@public/png/speaker-1.png"
import SpeakerOn from "@public/png/speaker-2.png"

const SUBHEADER = "CENTURY 21 Real Estate LCC adalah perusahaan broker properti terbesar di dunia. Markas besar di New Jersey, Amerika Serikat, beroperasi independen dengan 7.100 kantor waralaba di 75 negara dengan lebih dari 102.000 profesional penjualan."

const fullScreenButtonClass = `p-1.5 flex items-center justify-center rounded-[80px] border-solid
  border-[1px] border-black-1 cursor-pointer absolute z-20 top-4 right-4 bg-white`
const pauseButtonClass = `py-0.5 px-2 flex items-center justify-center rounded-[80px] border-solid
  border-[1px] border-black-1 cursor-pointer bg-white`

const URL = "https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/video.mp4"

const Hero = () => {
  const ref = useRef(null);

  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMute, setIsMute] = useState(true);

  const togglePlay = () => {
    if (ref.current.paused) {
      ref.current.play();
      setIsPlaying(true);
    } else {
      ref.current.pause();
      setIsPlaying(false);
    }
  };

  const toggleMute = () => {
    setIsMute(!isMute)
  };

  const toggleFullscreen = () => {
    if (ref.current) {
      if (ref.current.requestFullscreen) {
        ref.current.requestFullscreen();
      } else if (ref.current.mozRequestFullScreen) { // Firefox
        ref.current.mozRequestFullScreen();
      } else if (ref.current.webkitRequestFullscreen) { // Chrome, Safari, and Opera
        ref.current.webkitRequestFullscreen();
      } else if (ref.current.msRequestFullscreen) { // IE/Edge
        ref.current.msRequestFullscreen();
      } else {
        ref.current.play();
      }
    }
  };

  useEffect(() => {
    // Add an event listener for fullscreenchange
    const fullscreenChangeHandler = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', fullscreenChangeHandler);
    document.addEventListener('webkitfullscreenchange', fullscreenChangeHandler);
    document.addEventListener('mozfullscreenchange', fullscreenChangeHandler);
    document.addEventListener('MSFullscreenChange', fullscreenChangeHandler);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('fullscreenchange', fullscreenChangeHandler);
      document.removeEventListener('webkitfullscreenchange', fullscreenChangeHandler);
      document.removeEventListener('mozfullscreenchange', fullscreenChangeHandler);
      document.removeEventListener('MSFullscreenChange', fullscreenChangeHandler);
    };
  }, []);


  return (
    <>
      <div className='main-wrapper pt-[152px] pb-[104px] bg-white-3 
    dd-lg:pt-[128px]
    dd-md:pb-[80px] dd-md:pt-[96px]'>
        <div className='content-wrapper flex flex-col items-center justify-center'>
          <p className='mb-4 text-80 text-black-1 font-sfpro-bold text-center 
        dd-xl:text-52 
        dd-lg:text-start'>BROKER PROPERTI <br /> TERBESAR DI DUNIA</p>
          <p className='text-center text-17 text-grey-1 w-[760px] mb-[40px] 
        dd-xl:w-full 
        dd-lg:text-start'>{SUBHEADER}</p>

          <div className='relative flex justify-center w-[904px] h-[504px] rounded-[24px] border border-solid border-grey-0 
        dd-xl:w-full dd-xl:h-[365px] 
        dd-lg:h-[221px] 
        dd-md:h-[208px]'>
            <video
              loop
              autoPlay={isPlaying}
              muted={isMute}
              ref={ref}
              className={`object-cover rounded-[24px] w-full h-full ${isFullscreen && "!object-contain !rounded-[none]"}`}
            >
              <source src={URL} type="video/mp4" />
            </video>

            <button
              onClick={toggleFullscreen}
              className={fullScreenButtonClass}>
              <Image src={FullScreenIcon} alt='Fullscreen' width={20} height={20} />
            </button>

            <button
              onClick={toggleMute}
              className={`${fullScreenButtonClass} !right-[unset] left-4`}>
              <Image src={isMute ? SpeakerOff : SpeakerOn} alt='Mute' width={20} height={20} />
            </button>

            <div className='absolute z-20 bottom-4 flex items-center' onClick={togglePlay}>
              <button
                className={pauseButtonClass}>
                <span className='text-15 font-sfpro-heavy uppercase text-black'>TUNDA</span>
              </button>
              <div className={`bg-white border-solid rounded-[40px] border-[1px] border-black-1 w-6 h-6 object-contain p-1 flex items-center justify-center`}>
                <Image src={isPlaying ? PauseIcon : PlayIcon} alt='Pause Icon' width={16} height={16} className='object-contain' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Hero